/**
 * stepu MngBudgetDetailList.vue — 112/611 행 추가 시 `days`(월 이용·방문 횟수) 기본값과 동일.
 * CAION에서는 수가 선택의 "명(회)"에 대응하는 suga_times 로 사용.
 */
export function defaultSugaTimesByBizGubun(bizGubun: string): string {
  const b = (bizGubun || "").trim();
  const map: Record<string, string> = {
    공동생활가정: "30",
    방문목욕: "5",
    방문요양: "26",
    요양시설: "30",
    주야간보호: "25",
    방문간호: "26",
    복지용구: "20",
  };
  return map[b] ?? "20";
}

/** stepu: 수입 쌍·급여 관련 행에 month=12. CAION 예산의 연간 개월 필드 기본. */
export const DEFAULT_REVENUE_PAIR_MONTHS = "12";
